export class Page {
  // The number of elements in the page
  size = 55;
  // The total number of elements
  totalElements = 0;
  // The total number of pages
  totalPages = 0;
  // The current page number (starts at fukcing zero!!!)
  offset = 1;
}
